import {useMutation} from "@tanstack/react-query";
import {uploadRetailLocationsFile} from "../services/RetailLocationService";

export function useRetailLocationImport() {
    return useMutation({
        mutationFn: uploadRetailLocationsFile,
    });
}
